import { OrderPreparationApiAdapter } from '../adapters/OrderPreparationApiAdapter';
import { Filters, OrderPreparationModel } from '../models/OrderPreparation';

export interface Page {
  orderpreparation: OrderPreparationModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: OrderPreparationApiAdapter) {}

  async getAllPreparations(filters: Filters = {}): Promise<OrderPreparationModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedPreparations(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales para preparaciones
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getOrderPreparationPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getOrderPreparationPaginated(filters);
  }
}
